import { styled } from '@mui/material/styles';
import { ChatMessageText } from '../ChatMessageText';

export const ChatMessageSubject = styled(ChatMessageText, {
  shouldForwardProp: prop => prop !== '$hasText',
})<{ $hasText: boolean }>(({ theme, $hasText }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: $hasText ? theme.spacing(1) : 0,
}));
